require('./bootstrap');

import "@babel/polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueCurrencyFilter from "vue-currency-filter";
import "intersection-observer"; // Optional
import BootstrapVue from "bootstrap-vue";
import "./scss/custom.scss";
import AppHeader from "./components/AppHeader";
import NumberInputSpinner from "vue-number-input-spinner";
import Switcher from "./components/Switcher";
import InputSpinner from "./components/InputSpinner";
import Highcharts from "highcharts";

import VueDOMPurifyHTML from "vue-dompurify-html";
Vue.use(VueDOMPurifyHTML);

import HighchartsMore from "highcharts/highcharts-more";
HighchartsMore(Highcharts);

Highcharts.setOptions({
  lang: {
    decimalPoint: ",",
    thousandsSep: ".",
    numericSymbols: null
  }
});

import HighchartsVue from "highcharts-vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueMoment from "vue-moment";
//import VueAuthenticate from "vue-authenticate";

import ScreenLocker from "./components/ScreenLocker";
import Secure from "./components/AuthGuard";
import SvgViewer from "./components/SvgViewer";
import RadioSwitcher from "./components/RadioSwitcher";

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(NumberInputSpinner);
Vue.use(HighchartsVue, {
  highcharts: Highcharts
});
Vue.use(VueCurrencyFilter, {
  symbol: "€",
  thousandsSeparator: ".",
  fractionCount: 2,
  fractionSeparator: ",",
  symbolPosition: "front",
  symbolSpacing: true
});
Vue.use(VueAxios, axios);
Vue.use(VueMoment);

Vue.component("AppHeader", AppHeader);
Vue.component("Switcher", Switcher);
Vue.component("RadioSwitcher", RadioSwitcher);
Vue.component("InputSpinner", InputSpinner);
Vue.component("ScreenLocker", ScreenLocker);
Vue.component("AuthGuard", Secure);
// Vue.config.silent = true;
// Vue.component('inline-svg', InlineSvg);
// import {SimpleSVG} from 'vue-simple-svg'
Vue.component("svg-viewer", SvgViewer);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
